module.exports = __webpack_public_path__ + "img/world-map.da7717d3.png";